var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outline-button-container",class:_vm.rootClassName},[_c('button',{staticClass:"outline-button-button button"},[_vm._v(_vm._s(_vm.button1))])])}
var staticRenderFns = []

export { render, staticRenderFns }